import React from 'react';
import { Card, Text } from '@clockout-dev/design-elements';
import { clampPercent } from '../../../utils/numbers';
import styles from './styles/progress-summary-card.module.scss';

function ProgressSummaryCard({ title, subtitle, items = [] }) {
    return (
        <Card className={styles.card}>
            <div className={styles.header}>
                <Text as="span" className={styles.title}>{title}</Text>
                {subtitle ? <Text as="span" className={styles.subtitle}>{subtitle}</Text> : null}
            </div>
            <div className={styles.items}>
                {items.map((item) => (
                    <div className={styles.item} key={item.label}>
                        <div className={styles.itemHeader}>
                            <Text as="span" className={styles.itemLabel}>{item.label}</Text>
                            <Text as="span" className={styles.itemValue}>{item.value}</Text>
                        </div>
                        <div className={styles.track}>
                            <div
                                className={styles.fill}
                                style={{ width: `${clampPercent(item.percent)}%` }}
                            />
                        </div>
                    </div>
                ))}
            </div>
        </Card>
    );
}

export default ProgressSummaryCard;
